import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box } from '@mui/material';
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import BillPaymentsData from './billPaymentsData';

const BillPayments = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Handling Change when tab is changed
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // console.log('table data', tableData);

  return (
    <Page title="Bill Payments Report">
      <HeaderBreadcrumbs
        heading="Bill Payments Report"
        links={[{ name: 'Bill Payments' }]}
      />
      <Box sx={{ width: '100%' }}>
        <BillPaymentsData />
      </Box>
    </Page>
  );
};

export default BillPayments;
